import Box from "@mui/material/Box";
import GlobalStyles from "@mui/material/GlobalStyles";
import type { ApplicationState } from "core/redux/reducers/rootReducer";
import type React from "react";
import { useSelector } from "react-redux";
import { calcVisualisationsHeight } from "sequenceAnalyser/components/Sequences/SequenceTableVisualisations/utils.ts";

import styles, { selectionStyles } from "./SequencesStyling.style";

interface ComponentProps {
  children: React.ReactNode;
  hasFeatures: boolean;
  hasColors: boolean;
  hasVisualisations: boolean;
}

function SequencesStyling({ hasColors, hasFeatures, children, hasVisualisations }: ComponentProps) {
  const sidebarPixelWidth = useSelector((state: ApplicationState) => state.sequenceAnalyser.sidebarPixelWidth);
  const zoomLevel = useSelector((state: ApplicationState) => state.sequenceAnalyser.zoomLevel);
  const visualisations = useSelector((state: ApplicationState) => state.sequenceAnalyser.settings.visualisations);
  const visualisationsHeight = calcVisualisationsHeight(visualisations, zoomLevel);
  const classes = styles({ sidebarPixelWidth, visualisationsHeight });

  return (
    <>
      <GlobalStyles styles={selectionStyles} />

      <Box
        id="sequences"
        sx={classes.sequences}
        className={[
          `${hasColors ? "withColors" : ""}`,
          `${hasFeatures ? "withFeatures" : ""}`,
          `${hasVisualisations ? "withVisualisations" : ""}`,
        ].join(" ")}
      >
        {children}
      </Box>
    </>
  );
}

export default SequencesStyling;
